export default __webpack_public_path__ + "static/media/step-middle-active.8b549dfa.png";